import styled from 'styled-components';

export const LocaleLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: ${props => props.$padding || props.theme.spacing.none};
  min-width: 12rem;

  &:hover {
    color: ${props => props.theme.palette.actionablePrimary};
  }

  @media (min-width: ${props => props.theme.mediaMd}) {
    align-items: flex-start;
    padding: ${props => props.$padding || props.theme.spacing.md};
  }
`;

export const LocaleFooterMenuContainer = styled.div`
  width: 14.5rem;
  margin: 0 auto;
`;

export const LocaleModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
